import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { MapAskChrome } from "../../components/ai/MapAskChrome.js";
import { authenticatedRoute } from "../_authenticated.js";

const mapDetailSearchSchema = z.object({
  node: z.string().min(1).optional().catch(undefined),
  /** `?journey=1` (or true/"true") reveals superseded nodes on the canvas. */
  journey: z
    .union([z.literal("1"), z.literal(1), z.literal(true), z.literal("true")])
    .optional()
    .catch(undefined)
    .transform((v) => (v !== undefined ? true : undefined)),
});

export const ideationMapDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ideation/maps/$mapId",
  validateSearch: (search: Record<string, unknown>) => mapDetailSearchSchema.parse(search),
  component: MapDetailRoute,
});

const MapCanvas = lazyRouteComponent(
  () => import("@l30/web-atlas/pages/ideation.maps.detail.page"),
  "IdeationMapDetailPage",
);

function MapDetailRoute() {
  const { mapId } = ideationMapDetailRoute.useParams();
  return (
    <>
      <MapCanvas />
      <MapAskChrome mapId={mapId} />
    </>
  );
}
